import { BREAKPOINTS } from "../config/breakpoints";
import React, { useState } from "react";
import { errorNotification } from "../Generic/Notifications";
import { Table, Tbody, Tcol, Thead, Trow } from "../Generic/Table";
import EmptyState from "../Generic/EmptyState";
import styled from "styled-components";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as TaskActions from "./actions/taskActions";
import TaskService from "./services";
import { TASK_STATUSES } from "./TaskConstants";
import { beautifyKey, debounce } from "../util/util";
import Loader from "../Generic/Loader";
import AddFilters from "../Generic/AddFilters";
import Icons from "../Generic/SvgIcons";
import useQuery from "../util/hooks/useQuery";
import { formatDisplayDate, LIST_DISPLAY_DATE_FORMAT } from "../util/date.util";

const Page = styled.div`
	display: flex;
	height: max-content;
	overflow-y: auto;
	overflow-x: hidden;
	flex-direction: column;
	text-align: left;
	width: 100%;
	padding: 2rem;
	@media (max-width: ${BREAKPOINTS.tablet}px) {
		padding: 1rem;
	}
`;

const Header = styled.div`
	display: flex;
	font-size: 2rem;
	margin: 0 0 1rem 0.5rem;
	@media (max-width: ${BREAKPOINTS.tablet}px) {
		font-size: 1.5rem;
	}
`;

const CenteredContainer = styled.div`
	width: 100%;
	height: max-content;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin: ${(props) => props.margin};
`;

const TaskList = (props) => {
	const { machineID, kitchenId } = props;
	const pageQuery = useQuery();

	const [taskList, setTaskList] = useState([]);
	const taskGroupId = pageQuery.get("taskGroupId");
	const initialFilters = taskGroupId ? [{ type: "taskGroupId", value: taskGroupId }] : [];
	const [loading, setLoading] = useState(initialFilters.length ? true : false);

	async function getTasksByFilter(filters) {
		if (!filters?.length) {
			setTaskList([]);
			setLoading(false);
			return;
		}
	
		const response = await TaskService.getTasksByFilter(filters);
		const { data, error } = response;
		if (data) {
			setTaskList(data);
		}
		if (error) {
			errorNotification(error);
			console.log(error);
		}
		setLoading(false);
	}

	function navigateToTaskPage(taskId) {
		window.open(`/${machineID}/task/${taskId}`, "_blank", 'noopener,noreferrer'); // Open in new tab
	}

	function renderTaskList(tasks, loading) {
		if (tasks.length) {
			let tasksRenderData = tasks.map((task, index, array) => {
				const { _id, taskType, taskGroupId, status, actualEndTime, actualStartTime } = task;
				const endTimeString = actualEndTime ? formatDisplayDate(actualEndTime, LIST_DISPLAY_DATE_FORMAT) : "-";
				const startTimeString = actualStartTime ? formatDisplayDate(actualStartTime, LIST_DISPLAY_DATE_FORMAT) : "-";
				return (
					<Trow key={_id} clickable onClick={() => navigateToTaskPage(_id)}>
						<Tcol borderRadius="10px 0 0 10px">{_id}</Tcol>
						<Tcol>{beautifyKey(taskType)}</Tcol>
						<Tcol>{taskGroupId}</Tcol>
						<Tcol>{TASK_STATUSES[status]}</Tcol>
						<Tcol>{startTimeString}</Tcol>
						<Tcol borderRadius="0 10px 10px 0">{endTimeString}</Tcol>
					</Trow>
				);
			});
			return (
				<Table>
					<Trow head>
						<Thead>Task ID</Thead>
						<Thead>Task Type</Thead>
						<Thead>Task Group ID</Thead>
						<Thead>Task Status</Thead>
						<Thead>Start Time</Thead>
						<Thead>End Time</Thead>
					</Trow>
					<Tbody>{tasksRenderData}</Tbody>
				</Table>
			);
		} else if (!loading) {
			return <EmptyState />;
		}
	}

	function handleFiltersUpdate(filters, noDebounce = false) {
		setLoading(true);
		if (noDebounce) {
			getTasksByFilter(filters);
		} else {
			debounce(() => {
				getTasksByFilter(filters);
			}, 500);
		}
	}

	return (
		<Page>
			<Header>Search Tasks</Header>
			<AddFilters
				onUpdate={handleFiltersUpdate}
				filterTypes={[{ key: "taskGroupId", label: "Task Group ID", type: "text", icon: Icons.hash }]}
				initialFilters={initialFilters}
			/>

			{renderTaskList(taskList, loading)}
			{loading ? (
				<CenteredContainer>
					<Loader />
				</CenteredContainer>
			) : (
				""
			)}
		</Page>
	);
};

const mapStateToProps = (state) => {
	const { task, landing } = state;
	return { ...task, ...landing };
};

const mapDispatchToProps = (dispatch) => ({
	...bindActionCreators(
		{
			...TaskActions,
		},
		dispatch
	),
});

export default connect(mapStateToProps, mapDispatchToProps)(TaskList);
